module.exports = __webpack_public_path__ + "images/main-541944e4d7ded86c3fa617ef86341f73.jpg";